import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function PaymentReturn(props) {
    const { t } = useI18N();
    const close = (e) => {
        if (window.opener) {
            // we are in a popup
            //  window.opener.close()
        }
        else if (window.parent) {
            // we are in an iframe
            window.parent.close();
        }
        // we are normal happy people
        window.close();
    };
    return (_jsxs(BoxContainer, { children: [_jsx(Card, { sx: {
                    my: 4
                }, children: _jsx(CardContent, { children: _jsx(Typography, { component: "p", variant: "body2", sx: { textAlign: 'center' }, children: t('Je kunt dit venster nu sluiten om verder te gaan') }) }) }), _jsx(Button, { onClick: close, fullWidth: true, variant: "contained", children: t('Venster sluiten') })] }));
}
